import { useState, useEffect } from "react"
import { UiState } from "../managers/UIManager"

interface Props { state: UiState }

export default function ConsentScreen({ state }: Props) {
  const [consentChecked, setConsentChecked] = useState(false)
  const canStart = consentChecked && state.loadingProgress >= 100

  const handleCheck = (checked: boolean) => {
    setConsentChecked(checked)
    document.dispatchEvent(new CustomEvent("consentChanged", { detail: { consentGiven: checked } }))
  }

  const handleStart = () => {
    if (canStart) {
      document.dispatchEvent(new CustomEvent("startExperience", { detail: { consentGiven: true, timestamp: Date.now() } }))
    }
  }

  useEffect(() => {
    if (!state.consentGiven) setConsentChecked(false)
  }, [state.consentGiven])

  const btnLabel = !consentChecked
    ? "Please accept to continue"
    : state.loadingProgress < 100
    ? `Loading… ${Math.round(state.loadingProgress)}%`
    : "Get Started"

  return (
    <div className="consent-react">
      <div className="consent-react-inner">
        <div className="consent-react-logo-wrap">
          <img src="/rockarlogo.png" alt="ROCK AR" className="consent-react-logo" />
        </div>

        <div className="consent-react-hero">
          <h1 className="consent-react-title">Augment Your Style.<br />Redefine Reality.</h1>
          <p className="consent-react-sub">
            Point your camera at any ROCK AR design to unlock an immersive AR experience.
          </p>
        </div>

        <div className="consent-react-loading">
          <div className="consent-loading-bar-wrap">
            <div className="consent-loading-bar" style={{ width: `${state.loadingProgress}%` }} />
          </div>
          <span className="consent-loading-pct">{Math.round(state.loadingProgress)}%</span>
        </div>

        <div className="consent-react-checkbox-wrap">
          <label className="consent-react-label">
            <input
              type="checkbox"
              className="consent-react-check"
              checked={consentChecked}
              onChange={(e) => handleCheck(e.target.checked)}
            />
            <span className="consent-react-checkmark" />
            I agree to camera access, location tracking, and anonymous analytics.
          </label>
        </div>

        <button
          className={`consent-react-btn ${canStart ? "consent-btn-active" : ""}`}
          disabled={!canStart}
          onClick={handleStart}
        >
          {btnLabel}
        </button>

        <img src="/bottomlogobar.png" alt="Powered by ROCKaBLOCK" className="consent-react-footer-logo" />
      </div>
    </div>
  )
}
